import React from 'react'

const StyledTitle = ({title}) => {
    return (
        <div className="styled-title">
            <div></div>
            <h4>{title}</h4>
            <div></div>
        </div>
    )
}

export default StyledTitle
